// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import usePrevious from "@insite/client-framework/Common/Hooks/usePrevious";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import LoadingOverlay, { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import React from "react";

type Props = WidgetProps;

export interface OrderStatusPageContainerStyles {
    loadingOverlay?: LoadingOverlayProps;
    errorInfosBox?: InfosBoxProps;
}

export const orderStatusPageContainerStyles: OrderStatusPageContainerStyles = {
    loadingOverlay: { minHeight: 150 },
    errorInfosBox: { type: "error" },
};

const styles = orderStatusPageContainerStyles;

const OrderStatusPageContainer = ({ id }: Props) => {
    const { order, isLoading } = useAppSelector(state => state.pages.orderStatus);
    const previousIsLoading = usePrevious(isLoading);
    const { isEditing } = useShellContext();

    if (!isEditing && typeof isLoading === "undefined") {
        return null;
    }

    return (
        <LoadingOverlay loading={isLoading === true} {...styles.loadingOverlay}>
            {!isEditing && !order && (!isLoading || previousIsLoading === false) ? (
                <InfosBox {...styles.errorInfosBox}>{siteMessage("Order_NotFound")}</InfosBox>
            ) : (
                <OrderLayout id={id} />
            )}
        </LoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: OrderStatusPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Order Status",
        allowedContexts: ["OrderStatusPage"],
    },
};
export default widgetModule;
